// extracted by mini-css-extract-plugin
export default {"card":"Card_card__sHU3l","btnn":"Card_btnn__NHnZ1"};